/** Altura máxima para tabelas com cabeçalho fixo — evita `calc(100vh - X)` frágil. */
export const TABLE_STICKY_MAX_HEIGHT = 'min(72vh, 720px)'
